<template>
  <div class="row">
    <div class="col-12 card">
      <h4>Список заявок</h4>

      <!-- Фильтры в одной строке -->
      <div class="row filters">
        <div class="col-2">
          <div class="text-field">
            <label class="text-field__label">Дата с</label>
            <input
                class="text-field__input"
                type="date"
                v-model="filters.startDate"
                @change="applyFilters"
            >
          </div>
        </div>
        <div class="col-2">
          <div class="text-field">
            <label class="text-field__label">Дата по</label>
            <input
                class="text-field__input"
                type="date"
                v-model="filters.endDate"
                @change="applyFilters"
            >
          </div>
        </div>
        <div class="col-2">
          <div class="text-field">
            <label class="text-field__label">Номер авто</label>
            <input
                class="text-field__input"
                type="text"
                v-model="filters.carNumber"
                placeholder="Поиск по номеру"
                @input="applyFilters"
            >
          </div>
        </div>
        <div class="col-2">
          <div class="text-field">
            <label class="text-field__label">ФИО водителя</label>
            <input
                class="text-field__input"
                type="text"
                v-model="filters.driverName"
                placeholder="Поиск по ФИО"
                @input="applyFilters"
            >
          </div>
        </div>
        <div class="col-2">
          <button class="btn-secondary apply-btn" @click="applyFilters">
            <span class="icon-Search"></span>Применить
          </button>
        </div>
        <div class="col-2">
          <router-link to="/polygon/new_order" class="btn-primary new-order-btn">
            <span class="icon-Plus"></span>Новая заявка
          </router-link>
        </div>
      </div>

      <!-- Список заявок -->
      <div class="row top-24">
        <div class="col-12">
          <div v-if="loading" class="loading">Загрузка данных...</div>
          <div v-else-if="!paginatedOrders.length" class="no-data">
            Заявки не найдены
          </div>
          <table v-else width="100%" class="orders-table">
            <thead>
            <tr>
              <th>№ Заявки</th>
              <th>Автомобиль</th>
              <th>Водитель</th>
              <th>Дата и время</th>
              <th>Действия</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="order in paginatedOrders" :key="order.OrderID">
              <td>
                <strong>№{{ order.OrderID }}</strong>
              </td>
              <td>{{ order.OrderCar || 'Не указан' }}</td>
              <td>{{ order.OrderDriver || 'Не указан' }}</td>
              <td>
                <div class="date-time">
                  <div class="date">{{ format_date(order.OrderDate, 'date') }}</div>
                  <div class="time">{{ format_date(order.OrderDate, 'time') }}</div>
                </div>
              </td>
              <td>
                <div class="actions">
                  <router-link
                      v-if="!order.OrderStatus"
                      :to="getEditOrderLink(order)"
                      class="action-btn edit-btn"
                      title="Изменить"
                  >
                    <span class="icon-Edit"></span> Изменить
                  </router-link>
                  <router-link
                      :to="getCopyOrderLink(order)"
                      class="action-btn copy-btn"
                      title="Копировать"
                  >
                    <span class="icon-Copy"></span> Копировать
                  </router-link>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row top-24" v-if="totalPages > 1">
        <div class="col-12 pagination">
          <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="page-btn"
          >
            ←
          </button>
          <button
              v-for="page in visiblePages"
              :key="page"
              @click="currentPage = page"
              :class="['page-btn', currentPage === page ? 'active' : '']"
          >
            {{ page }}
          </button>
          <button
              @click="nextPage"
              :disabled="currentPage === totalPages"
              class="page-btn"
          >
            →
          </button>
          <span class="pagination-info">
            Показано {{ showingFrom }}-{{ showingTo }} из {{ filteredOrders.length }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      title: "Список рейсов",
      loading: false,
      filters: {
        startDate: '2024-01-01',
        endDate: this.today_date(),
        carNumber: '',
        driverName: ''
      },
      currentPage: 1,
      itemsPerPage: 10
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    canCopyOrder() {
      const allowedINNs = ['5257084971', '5837067698', '5260462711', '5257016604'];
      const userINN = String(this.currentUser.company_inn);
      console.log('AllContracts - User INN:', userINN, 'Type:', typeof this.currentUser.company_inn);
      console.log('AllContracts - Can copy:', allowedINNs.includes(userINN));
      return allowedINNs.includes(userINN);
    },
    Orders() {
      return this.$store.state.polygon_orders;
    },
    ordersList() {
      const orders = this.$store.state.polygon_orders?.Orders || [];

      // Дополняем данные из localStorage
      const savedOrders = JSON.parse(localStorage.getItem('orderDetails') || '{}');

      return orders.map(order => {
        const savedData = savedOrders[order.OrderID];
        if (savedData) {
          return {
            ...order,
            ContractID: savedData.ContractID || order.ContractID || '',
            WasteTypes: savedData.WasteTypes || order.WasteTypes || [],
            WasteProcents: savedData.WasteProcents || order.WasteProcents || []
          };
        }
        return order;
      });
    },
    filteredOrders() {
      return this.ordersList.filter(order => {
        const orderDate = moment(order.OrderDate).format('YYYY-MM-DD');
        const matchesDate = orderDate >= this.filters.startDate &&
            orderDate <= this.filters.endDate;

        const matchesCar = this.filters.carNumber === '' ||
            (order.OrderCar && order.OrderCar.toLowerCase().includes(this.filters.carNumber.toLowerCase()));

        const matchesDriver = this.filters.driverName === '' ||
            (order.OrderDriver && order.OrderDriver.toLowerCase().includes(this.filters.driverName.toLowerCase()));

        return matchesDate && matchesCar && matchesDriver;
      }).sort((a, b) => new Date(b.OrderDate) - new Date(a.OrderDate));
    },
    totalPages() {
      return Math.ceil(this.filteredOrders.length / this.itemsPerPage);
    },
    paginatedOrders() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredOrders.slice(start, start + this.itemsPerPage);
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    showingFrom() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    showingTo() {
      return Math.min(this.currentPage * this.itemsPerPage, this.filteredOrders.length);
    }
  },
  watch: {
    filters: {
      handler() {
        this.currentPage = 1;
      },
      deep: true
    }
  },
  methods: {
    hasValidWasteTypes(order) {
      // Проверяем, есть ли виды отходов и не являются ли они пустыми строками
      if (!order.WasteTypes || !Array.isArray(order.WasteTypes)) {
        return false;
      }

      // Проверяем, что нет пустых строк или строк состоящих только из пробелов
      const hasEmptyWaste = order.WasteTypes.some(waste => {
        return !waste || waste.trim() === '' || waste.trim() === ' ';
      });

      return !hasEmptyWaste;
    },
    getCopyOrderLink(order) {
      const contractID = order.ContractID || order.OrderContract || order.Contract || '';

      const query = {
        previous_OrderCar: order.OrderCar || '',
        previous_OrderDriver: order.OrderDriver || ''
      };

      // Добавляем договор если он есть
      if (contractID) {
        query.previous_OrderContract = contractID;

        // Добавляем виды отходов ТОЛЬКО если есть договор И они валидны
        if (this.hasValidWasteTypes(order)) {
          query.previous_WasteTypes = order.WasteTypes;
          query.previous_WasteProcents = (order.WasteProcents || []).map(p => Number(p).toFixed(3));
          console.log('Копирование с договором и видами отходов:', contractID, order.WasteTypes);
        } else {
          console.log('Копирование с договором, но БЕЗ видов отходов (пустые строки):', contractID);
        }
      } else {
        console.log('Копирование БЕЗ договора и БЕЗ видов отходов');
      }

      return {
        name: 'new_order',
        query: query
      };
    },
    getEditOrderLink(order) {
      const contractID = order.ContractID || order.OrderContract || order.Contract || '';

      const query = {
        previous_OrderID: order.OrderID || '',
        previous_OrderDate: order.OrderDate ? order.OrderDate.split('T')[0] : '',
        previous_OrderCar: order.OrderCar || '',
        previous_OrderDriver: order.OrderDriver || ''
      };

      // Добавляем договор если он есть
      if (contractID) {
        query.previous_OrderContract = contractID;

        // Добавляем виды отходов ТОЛЬКО если есть договор И они валидны
        if (this.hasValidWasteTypes(order)) {
          query.previous_WasteTypes = order.WasteTypes;
          query.previous_WasteProcents = (order.WasteProcents || []).map(p => Number(p).toFixed(3));
          console.log('Редактирование с договором и видами отходов:', contractID, order.WasteTypes);
        } else {
          console.log('Редактирование с договором, но БЕЗ видов отходов (пустые строки):', contractID);
        }
      } else {
        console.log('Редактирование БЕЗ договора и БЕЗ видов отходов');
      }

      return {
        name: 'edit_order',
        query: query
      };
    },
    today_date() {
      return moment().format('YYYY-MM-DD');
    },
    format_date(value, type = 'full') {
      if (value) {
        if (type === 'date') {
          return moment(String(value)).format('DD.MM.YYYY');
        } else if (type === 'time') {
          return moment(String(value)).format('HH:mm');
        } else {
          return moment(String(value)).format('DD.MM.YYYY HH:mm');
        }
      }
      return '';
    },
    applyFilters() {
      this.loading = true;
      this.$store.dispatch("fetchPolygonOrders", {
        inn: this.currentUser.company_inn,
        start_date: this.filters.startDate,
        end_date: this.filters.endDate
      }).finally(() => {
        this.loading = false;
        this.currentPage = 1;
      });
    },
    resetFilters() {
      this.filters = {
        // TODO: можно заменить на автоматическое определение даты первого дня текущего месяца для startDate, чтобы не приходилось вручную менять дату в коде каждый год
        startDate: '2024-01-01',
        endDate: this.today_date(),
        carNumber: '',
        driverName: ''
      };
      this.applyFilters();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    }
  },
  created() {
    this.loading = true;
    this.$store.dispatch("fetchPolygonOrders", {
      inn: this.currentUser.company_inn,
      start_date: this.filters.startDate,
      end_date: this.filters.endDate
    }).finally(() => {
      this.loading = false;
    });
  }
};
</script>

<style scoped>
.filters {
  margin-bottom: 20px;
  gap: 15px;
  align-items: flex-end;
}

.apply-btn, .new-order-btn {
  margin-top: 24px;
  min-width: 140px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  table-layout: auto;
}

.orders-table th,
.orders-table td {
  padding: 12px 8px;
  text-align: left;
  border-bottom: 1px solid #eee;
  vertical-align: top;
}

.orders-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  white-space: nowrap;
}

.orders-table td {
  word-wrap: break-word;
}

.date-time {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 100px;
}

.date {
  font-weight: 500;
  font-size: 13px;
  color: #333;
}

.time {
  font-size: 12px;
  color: #666;
  font-family: monospace;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 120px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid transparent;

  font-size: 14px;
  font-weight: 600;
  line-height: 1;

  background: #4f46e5;
  color: #fff;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);
  cursor: pointer;
  transition: transform .2s ease, box-shadow .2s ease, background-color .2s ease, border-color .2s ease;
}

.copy-btn {
  background-color: #e3f2fd;
  color: #1976d2;
  border: 1px solid #bbdefb;
}

.copy-btn:hover {
  background-color: #bbdefb;
  color: #0d47a1;
}

.edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid transparent;

  font-size: 14px;
  font-weight: 600;
  line-height: 1;

  background: #4f46e5;
  color: #fff;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);
  cursor: pointer;
  transition: transform .2s ease, box-shadow .2s ease, background-color .2s ease, border-color .2s ease;
}

.edit-btn:hover {
  background: #4338ca;
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.32);
  transform: translateY(-1px);
}

.loading, .no-data {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.page-btn {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  border-radius: 4px;
  min-width: 40px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-btn:hover:not(:disabled) {
  background-color: #f8f9fa;
}

.page-btn.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info {
  margin-left: 16px;
  color: #666;
  font-size: 14px;
}

.text-field__label {
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
  color: #333;
  font-size: 13px;
}

.text-field__input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  height: 40px;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .filters {
    flex-direction: column;
    gap: 10px;
  }

  .filters > div {
    width: 100%;
  }

  .apply-btn, .new-order-btn {
    margin-top: 0;
    width: 100%;
  }

  .orders-table {
    font-size: 14px;
  }

  .actions {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .action-btn {
    min-width: 80px;
    font-size: 11px;
    padding: 4px 8px;
  }
}
</style>